export default "__VITE_ASSET__jZLLvrO8__"